<template>
  <div :class="$style.wrapper" :style="{ background }">
    <VcHeader
      v-if="hasHeader"
      ref="header"
      :is-transparent="isHeaderTransparent"
      :has-navigation="hasHeaderNavigation"
    />
    <div :class="[$style.page, 
      {
        [$style.pending]: isPending && hasLoader,
        [$style.noHeader]: !hasHeader,
        [$style.noHeaderNavigation]: hasHeader && !hasHeaderNavigation
      }
    ]"  >
      <slot :is-mobile-layout="isMobileLayout" />
    </div>
    <VcFooter v-if="hasFooter" />
    <slot name="overlay" />
  </div>
</template>

<script>
import VcHeader from './VcHeader.vue'
import VcFooter from './VcFooter.vue'

export default {
  components: {
    VcHeader,
    VcFooter
  },
  props: {
    background: {
      type: String,
      required: false,
      default: '#fff'
    },
    hasHeader: {
      type: Boolean,
      required: false,
      default: true
    },
    isHeaderTransparent: {
      type: Boolean,
      required: false,
      default: false
    },
    hasHeaderNavigation: {
      type: Boolean,
      required: false,
      default: true
    },
    hasFooter: {
      type: Boolean,
      required: false,
      default: true
    },
    isPending: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      windowWidth: 0
    }
  },
  computed: {
    isMobileLayout() {
      return this.windowWidth <= 768
    }
  },
  mounted() {
    document.body.classList.remove('g-no-scroll')


    window.addEventListener('resize', this.onWindowResize)
    this.onWindowResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onWindowResize)
  },
  methods: {
    
    onWindowResize() {
      this.windowWidth = window.innerWidth
    }
  }
}
</script>

<style module>
.wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow-x: hidden;
}
.page {
  position: relative;
  margin: 0 auto;
  padding-top: calc(var(--header-height, 56px) + var(--header-nav-height, 0px));
  width: 100%;
  /* max-width: 1280px; */
  height: 100%;
  z-index: 2;
  transition: opacity 0.2s;
}

.page.noHeader {
  padding-top: 0;
}

.page.noHeaderNavigation {
  padding-top: var(--header-height, 56px);
}

.pending {
  opacity: 0;
}

</style>
